import React from "react";
import { useTranslation } from "react-i18next";
import IndexRow from "../IndexRow";
import BenchmarkRow from "../BenchmarkRow";
import SummaryRow from "../SummaryRow";
import "./styles.sass";

const Table = React.memo(({ items, familyId, subfamilyId = null }) => {
  const { t, i18n } = useTranslation();
  const isLtr = i18n.language === 'en';
  const filterByFamily = (family, subfamily) => {
    return items?.filter(
      (obj) =>
        obj.family === family &&
        (subfamily ? obj.subfamily === subfamily : true)
    );
  };

  let indices = [];
  if (familyId !== null) {
    if (familyId === "stocks") {
      if (subfamilyId === "1") {
        indices = filterByFamily("מדדי מניות", 'מדדי חו"ל');
      } else if (subfamilyId === "2") {
        indices = filterByFamily("מדדי מניות", "מדדי ישראל");
      } else if (subfamilyId === "3") {
        indices = filterByFamily("מדדי מניות", "דדים גלובליים");
      } else {
        indices = filterByFamily("מדדי מניות");
      }
    } else if (familyId === "bonds") {
      if (subfamilyId === "1") {
        indices = filterByFamily('מדדי אג"ח', "ממשלתי");
      } else if (subfamilyId === "2") {
        indices = filterByFamily('מדדי אג"ח', "קונצרני");
      } else {
        indices = filterByFamily('מדדי אג"ח');
      }
    } else if (familyId === "ai") {
      if (subfamilyId === "1") {
        indices = filterByFamily("AI מדדי", "מניות");
      } else if (subfamilyId === "2") {
        indices = filterByFamily("AI מדדי", 'אג"ח');
      } else {
        indices = filterByFamily("AI מדדי");
      }
    } else {
      indices = items;
    }
  } else {
    indices = items;
  }

  indices.sort((a, b) => {
    if (a?.parent_index && !b?.parent_index) {
      return -1; // a comes before b
    } else if (!a?.parent_index && b?.parent_index) {
      return 1; // b comes before a
    } else {
      return a?.name.localeCompare(b?.name);
    }
  });

  return (
    <table className="family-table" cellSpacing="0" rules="all" border="1">
      <thead className="family-table-header">
        <tr>
          <th rowSpan="2" className="family-table-header-cell" scope="col">
            {t('StatisticsTable.index')}
          </th>
          <th colSpan="3" className="family-table-header-cell" dir={isLtr ? 'ltr' : 'rtl'}>
          {t('StatisticsTable.return')} (%)
          </th>
          <th colSpan="8" className="family-table-header-cell" dir={isLtr ? 'ltr' : 'rtl'}>
          {t('StatisticsTable.average_annual_return')} (%)
          </th>
        </tr>
        <tr>
          <th
            scope="col"
            className="family-table-header-cell family-table-header-cell-height"
          >
           {t('StatisticsTable.day')}
          </th>
          <th
            scope="col"
            className="family-table-header-cell family-table-header-cell-height"
            dangerouslySetInnerHTML={{ __html: t('StatisticsTable.start_of_year') }}
          >
          </th>
          <th
            scope="col"
            className="family-table-header-cell family-table-header-cell-height"
          >
            {t('StatisticsTable.year')}
          </th>
          <th
            scope="col"
            className="family-table-header-cell family-table-header-cell-height"
            dangerouslySetInnerHTML={{ __html: t('StatisticsTable.3_years') }}
          >

          </th>
          <th
            scope="col"
            className="family-table-header-cell family-table-header-cell-height"
            dangerouslySetInnerHTML={{ __html: t('StatisticsTable.5_years') }}
          >
          </th>
          <th
            scope="col"
            className="family-table-header-cell family-table-header-cell-height"
            dangerouslySetInnerHTML={{ __html: t('StatisticsTable.10_years') }}
          >
          </th>
          <th
            scope="col"
            className="family-table-header-cell family-table-header-cell-height"
            dangerouslySetInnerHTML={{ __html: t('StatisticsTable.15_years') }}
          >
          </th>
        </tr>
      </thead>
      <tbody dir={isLtr ? 'ltr' : 'rtl'}>
        {indices.length === 0 ? (
          <tr>
            <td colSpan="12">No data available</td>
          </tr>
        ) : (
          indices.map(
            (index) =>
              index?.show_on_site && (
                <React.Fragment key={index.id}>
                  <IndexRow
                    index={index}
                    statistics={index?.statistics?.index_return[0]}
                  />
                  <BenchmarkRow
                    benchmark={items.find(
                      (obj) => obj?.id === index?.parent_index
                    )}
                    statistics={index?.statistics?.benchmark_return[0]}
                  />
                  <SummaryRow
                    index={index?.statistics?.index_return[0]}
                    benchmark={index?.statistics?.benchmark_return[0]}
                  />
                </React.Fragment>
              )
          )
        )}
      </tbody>
    </table>
  );
});
export default Table;
